import { render, staticRenderFns } from "./add-cinema-category-form.vue?vue&type=template&id=9a0a0d90&"
import script from "./add-cinema-category-form.vue?vue&type=script&lang=ts&"
export * from "./add-cinema-category-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports